import React, { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import api from '../utils/api';

// Handles the #session_id=... fragment returned by Emergent Google Auth.
// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
const AuthCallback = () => {
  const navigate = useNavigate();
  const { setTokensFromOAuth } = useAuth();
  const hasProcessed = useRef(false);
  const [error, setError] = useState('');

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;
    const run = async () => {
      const hash = window.location.hash || '';
      const match = hash.match(/session_id=([^&]+)/);
      const sessionId = match ? decodeURIComponent(match[1]) : '';
      if (!sessionId) { setError('Missing session_id'); return; }
      try {
        const { data } = await api.post('/auth/google/exchange', { session_id: sessionId });
        await setTokensFromOAuth(data.access_token, data.refresh_token);
        // Clear hash and redirect
        window.history.replaceState({}, document.title, window.location.pathname);
        navigate('/dashboard', { replace: true });
      } catch (e) {
        setError(e?.response?.data?.detail || 'Google sign-in failed. Please try again.');
        setTimeout(() => navigate('/auth', { replace: true }), 2500);
      }
    };
    run();
  }, [navigate, setTokensFromOAuth]);

  return (
    <div className="min-h-screen bg-[#050505] flex items-center justify-center" data-testid="oauth-callback">
      <div className="text-center">
        {error ? (
          <>
            <div className="text-red-400 text-lg font-semibold mb-2">Sign-in failed</div>
            <div className="text-zinc-500 text-sm">{error}</div>
            <div className="text-zinc-600 text-xs mt-4">Redirecting you back...</div>
          </>
        ) : (
          <>
            <div className="w-10 h-10 border-2 border-brand-primary border-t-transparent rounded-full animate-spin mx-auto mb-4" />
            <div className="text-white text-sm">Signing you in with Google...</div>
          </>
        )}
      </div>
    </div>
  );
};

export default AuthCallback;
